import ReportCompliteModal from './ReportCompliteModal';

export default ReportCompliteModal;
